import React from 'react';

const DefaultRootSubHeader = ({ title, description }) => (
  <div className="default-type-root-sub-header default-type-object-title">
    {title && <div className="default-type-title">{title}</div>}
    {description && (
      <div className="default-type-description">{description}</div>
    )}
  </div>
);

export default DefaultRootSubHeader;
